import {
  CategoryAnnouncementThumbnail,
  CategoryDefaultThumbnail,
  CategoryRandomThumbnail,
  CategoryTechnologyThumbnail,
  CategoryUserExperienceThumbnail,
  DummyBanner,
} from "../images/images"

/** ------------------------------------------------------------------------
 * !TODO
 *
 * Missing:
 * AWS
 * Recruitement (採用関連)
 * Uncategorized
 */

type CategorySetting = { thumbnail: string; color: string }

const DEFAULT_CATEGORY_SETTING: CategorySetting = {
  thumbnail: CategoryDefaultThumbnail,
  color: "black",
}

const WP_DB_ID = {
  ALL: null, // 全て
  TECHNOLOGY: 866, // テクノロジー
  UI_UX: 867,
  TIPS: 929, // ノウハウ・TIPS
  MONACA: 936,
  EVERYDAY: 868, //日常
  NEWS: 869, //お知らせ
  OTHER: 939, //その他
  AWS: 893, // AWS
  DAILY_THINGS: 868, // 日常
  WORKPLACE: 865, // 社内風景
  RECRUITMENT: 906, // 採用関連
  TRY_NEW: 933, // やってみた
} as const

export const CATEGORY_SETTINGS = [
  {
    databaseId: null,
    name: "すべて",
    path: "/all/",
  },
  {
    databaseId: WP_DB_ID.TECHNOLOGY,
    name: "テクノロジー",
    color: "#66c56f",
    thumbnail: CategoryTechnologyThumbnail,
    path: "/technology/",
  },
  {
    databaseId: WP_DB_ID.UI_UX,
    name: "UX / UI",
    color: "#00d1cf",
    thumbnail: CategoryUserExperienceThumbnail,
    path: "/ux-ui/",
  },
  {
    databaseId: WP_DB_ID.TIPS,
    name: "ノウハウ & Tips",
    color: "#d0b002",
    thumbnail: CategoryDefaultThumbnail,
    path: "/tips/",
  },
  {
    databaseId: WP_DB_ID.MONACA,
    name: "Monaca",
    color: "#5276f4",
    thumbnail: CategoryDefaultThumbnail,
    path: "/monaca/",
  },
  {
    databaseId: WP_DB_ID.OTHER,
    name: "その他",
    color: "#b662d3",
    thumbnail: CategoryDefaultThumbnail,
    path: "/random-things/",
  },
  {
    databaseId: WP_DB_ID.AWS,
    name: "AWS",
    color: "#FF3F39",
    thumbnail: CategoryDefaultThumbnail,
    path: "/aws/",
  },
  {
    databaseId: WP_DB_ID.DAILY_THINGS,
    name: "日常",
    color: "#C18121",
    thumbnail: CategoryRandomThumbnail,
    path: "/random/",
  },
  {
    databaseId: WP_DB_ID.WORKPLACE,
    name: "社内風景",
    color: "#A7BC22",
    thumbnail: CategoryDefaultThumbnail,
    path: "/working-atmoshpere/",
  },
  {
    databaseId: WP_DB_ID.RECRUITMENT,
    name: "採用関連",
    color: "#01A3C7",
    thumbnail: CategoryDefaultThumbnail,
    path: "/recruitment/",
  },
  {
    databaseId: WP_DB_ID.TRY_NEW,
    name: "やってみた",
    color: "#987AEE",
    thumbnail: CategoryDefaultThumbnail,
    path: "/try/",
  },
  {
    databaseId: WP_DB_ID.NEWS,
    name: "お知らせ",
    color: "#FE6083",
    thumbnail: CategoryAnnouncementThumbnail,
    path: "/announcement/",
  },
]
export const HEADER_CATEGORY_IDS = [
  WP_DB_ID.ALL,
  WP_DB_ID.TECHNOLOGY,
  WP_DB_ID.UI_UX,
  WP_DB_ID.TIPS,
  WP_DB_ID.MONACA,
  WP_DB_ID.TIPS,
  WP_DB_ID.OTHER,
]
export const HEADER_CATEGORY = CATEGORY_SETTINGS.filter(cs =>
  HEADER_CATEGORY_IDS.includes(cs.databaseId as any)
).sort(
  (a, b) =>
    HEADER_CATEGORY_IDS.indexOf(a.databaseId as any) -
    HEADER_CATEGORY_IDS.indexOf(b.databaseId as any)
)

export const getCategorySettings = (databaseId?: number) => {
  return databaseId
    ? CATEGORY_SETTINGS.find(cs => cs.databaseId === databaseId) ||
        DEFAULT_CATEGORY_SETTING
    : DEFAULT_CATEGORY_SETTING
}
export const getCategoryHeader = (databaseId?: number) => {
  return databaseId
    ? CATEGORY_SETTINGS.find(c => c.databaseId === databaseId)
    : CATEGORY_SETTINGS.find(c => c.databaseId === WP_DB_ID.OTHER)
}
export const getCategoryColorWithId = (databaseId?: number) => {
  return databaseId
    ? CATEGORY_SETTINGS.find(c => c.databaseId === databaseId)?.color ||
        undefined
    : undefined
}

/** ------------------------------------------------------------------------
 * Banners for the marketing footer
 * If nothing is provieded, the white Asial logo will appear
 */
export const BANNERS: { image?: any }[] = [{ image: DummyBanner }, {}, {}]

/** ------------------------------------------------------------------------
 * Products under the Asial logo on the footer
 */
export const PRODUCTS: { text: string; link: string }[] = [
  { text: "Monaca", link: "https://ja.monaca.io" },
  { text: "Onsen UI", link: "https://ja.onsen.io" },
  {
    text: "エンジニアリングで世界をちょっとよくするノート",
    link: "https://note.asial.co.jp",
  },
]

/** ------------------------------------------------------------------------
 * Static texts
 */
export const TEXTS = {
  subtitle: "アシアルの中の人が技術と想いのたけをつづるブログ",
  copyright: "© 2006- Asial Corporation",
  relatedPosts: {
    title: "Related",
    tag: "関連記事",
  },
  breadcrumbs: {
    home: "アシアルTechブログ",
  },
  categoryBrowser: {
    allPosts: "すべての記事",
  },
  menu: {
    categories: {
      title: "Categories",
      subtitle: "カテゴリ一覧",
    },
    archives: {
      title: "Archives",
      subtitle: "アーカイブ",
    },
    tags: {
      title: "Tags",
      subtitle: "タグ一覧",
    },
  },
} as const

export const DEFAULT_SEO_IMAGE = "/wp-content/uploads/2022/07/default.png"
